import { Box } from 'reflexbox';

import { useSessionSlots } from '@treams/treams-hooks';
import { AppLayout, Container, Paragraph, Sidebar, Skeleton, Title } from '@treams/treams-ui';

import TopBar from '../../../../navigation/TopBar';
import FullPageLoadingSpinner from './FullPageLoadingSpinner';

export default function FullPageLoadingSkeleton() {
	const { slots } = useSessionSlots();

	if (slots.length === 0) {
		return <FullPageLoadingSpinner />;
	}

	return (
		<AppLayout
			nav={
				<Sidebar p={3}>
					<Box mb={3}>
						<Skeleton.Box width={140} height={50} />
					</Box>
					<Skeleton.Repeat count={3}>
						<Sidebar.Item.Skeleton />
					</Skeleton.Repeat>
				</Sidebar>
			}
			header={<TopBar.Skeleton />}
		>
			<Container py={4}>
				<Title.Skeleton width={200} mb={3} />
				<Paragraph.Skeleton width={300} mb={3} lines={5} />
				<Paragraph.Skeleton width={240} mb={3} lines={3} />
				<Paragraph.Skeleton width={320} mb={3} lines={4} />
			</Container>
		</AppLayout>
	);
}
